import { environment } from "../environments/environment";

export const isDevEnv = () => {
  return environment.appEnv === "development";
};

export const isCanaryTestEnv = () => {
  return environment.appEnv === "canaryTest";
};

export const isProdEnv = () => {
  return environment.appEnv === "production";
};
